// extracted by mini-css-extract-plugin
module.exports = {"patientForm":"patient-form__3XR-0","spinnerContainer":"spinner-container__1z8li","radioClass":"radio-class__1CrN9"};